import React, { useContext } from "react";
import { GlobalInfo } from "../App";
import { Link } from "react-router-dom";
export default function Request(props) {
  const { getreqid, getpendingid } = useContext(GlobalInfo);
  return (
    <>
      <div className="Req">
        {props.cat.completed === true ? (
          <div
            className="card"
            style={{
              width: "18rem",
              border: "2px solid black",
              backgroundColor: "red",
            }}
          >
            <img
              src={props.cat.file_hash}
              className="card-img-top"
              alt="..."
              style={{ width: "17rem", margin: "auto" }}
            />
            <div className="card-body">
              <h5 className="card-title" id="cat">
                Category:- {props.cat.category}
              </h5>
              <h5 className="card-title" id="des">
                Description:-{props.cat.description}{" "}
              </h5>
              <h5 className="card-title" id="com">
                Status:-{props.cat.completed ? "Yes" : "No"}{" "}
              </h5>
              {props.cat.approved === true ? (
                <Link
                  className="btn-sm btn-primary"
                  onClick={() => getreqid(props?.cat)}
                  to="/info"
                >
                  see More
                </Link>
              ) : (
                <Link
                  className="btn-sm btn-primary"
                  onClick={() => getpendingid(props?.cat)}
                  to="/Status"
                >
                  see status
                </Link>
              )}
            </div>
          </div>
        ) : (
          <div
            className="card"
            style={{ width: "18rem", border: "2px solid black" }}
          >
            <img
              src={props.cat.file_hash}
              className="card-img-top"
              alt="..."
              style={{ width: "17rem", margin: "auto" }}
            />
            <div className="card-body">
              <h5 className="card-title" id="cat">
                Category:- {props.cat.category}
              </h5>
              <h5 className="card-title" id="des">
                Description:-{props.cat.description}{" "}
              </h5>
              <h5 className="card-title" id="com">
                Status:-{props.cat.completed ? "Yes" : "No"}{" "}
              </h5>
              {props.cat.approved === true ? (
                <Link
                  className="btn-sm btn-primary"
                  onClick={() => getreqid(props?.cat)}
                  to="/info"
                >
                  see More
                </Link>
              ) : (
                <Link
                  className="btn-sm btn-primary"
                  onClick={() => getpendingid(props?.cat)}
                  to="/Status"
                >
                  see status
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
